module.exports = __webpack_public_path__ + "static/panda-panel-preview-8448a4895cec2a1f9326e2adf2c93213.svg";